<ui-form-section
  [title]="title()"
  [showAddButton]="true"
  [addLabel]="addLabel()"
  (addClick)="add.emit()"
>
  <ui-compact-list
    [columns]="columns()"
    [rows]="rows()"
    [rowKey]="rowKey()"
    [rowTitleKey]="rowTitleKey()"
    [emptyText]="emptyText()"
    (edit)="edit.emit($event)"
    (delete)="delete.emit($event)"
  />
  <ui-invoice-subtotal-check
    [items]="rows()"
    [expectedSubtotal]="expectedSubtotal()"
    singularLabel="comprobante"
    pluralLabel="comprobantes"
  />
</ui-form-section>
